import { render, staticRenderFns } from "./TrafficFineView.vue?vue&type=template&id=b04078ba&"
import script from "./TrafficFineView.vue?vue&type=script&lang=js&"
export * from "./TrafficFineView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports